<div class="header">
  <div class="row">
    <div class="col-md">
      <h3>{{'MENU.EMAIL-DASHBOARD' | translate}}</h3>
      <h6>{{'CHART.TOTAL' | translate}}: {{emailTotal}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
    </div>
  </div>
</div>
<div class="row mr-0">
  <div class="col-3  d-flex flex-row">
    <div class="ts-box sentChart flex-column" [ngClass]="{'selected-sentChart': docType === 'sent'}"
         (click)="filterStatus('success')" style="overflow: hidden">
      <h5 class="text-center mt-2 mb-0">{{'EMAIL-DASHBOARD.SENT' | translate}}</h5>
      <div class="canvas mt-4">
        <canvas id="sentChart">{{myChart1}}</canvas>
      </div>
      <h6 class="text-center mb-2">{{transactions_sent}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
    </div>
    <div class="ts-box errorsChart flex-column" [ngClass]="{'selected-errorsChart': docType === 'errors'}"
         (click)="filterStatus('failed')" style="overflow: hidden">
      <h5 class="text-center mt-2 mb-0">{{'EMAIL-DASHBOARD.FAILED' | translate}}</h5>
      <div class="canvas mt-4">
        <canvas id="errorChart">{{myChart2}}</canvas>
      </div>
      <h6 class="text-center mb-2">{{transactions_failed}} {{'EMAIL-DASHBOARD.TRANSACTION' | translate}}</h6>
    </div>
  </div>
  <div class="box-filter col-9">
    <div class="col-12 searchBox_inner">
      <app-filter-header [loading]="loading" (search)="searchButtonClicked()"
                         (clear)="clearData()"></app-filter-header>
    </div>
    <div class="row row-eq-height">
      <div class="col-4 pl-3 pr-0">
        <div class="dropdown-label-group">
          <p-dropdown
            class="dv-dropdown"
            selectId="company"
            [options]="company"
            [(ngModel)]="selectedCompany"
            (onChange)="filterBranchList()"
            [autoDisplayFirst]="false"
            id="company"
            placeholder="{{'FILTER.COMPANY' | translate}}"
            [style]="{'z-index': 3}">
          </p-dropdown>
          <label for="company">{{'FILTER.COMPANY' | translate}}</label>
        </div>
      </div>
      <div class="col-4 px-2">
        <div class="dropdown-label-group">
          <p-dropdown
            class="dv-dropdown"
            selectId="companyBranch"
            [options]="branchList"
            [(ngModel)]="selectedBranch"
            [autoDisplayFirst]="false"
            id="branch"
            placeholder="{{'FILTER.BRANCH' | translate}}"
            [style]="{'z-index': 3}">
          </p-dropdown>
          <label for="companyBranch">{{'FILTER.BRANCH' | translate}}</label>
        </div>
      </div>
      <div class="col-4 pr-3 pl-0">
        <div class="dropdown" #dd="ngbDropdown" ngbDropdown placement="bottom-right" autoClose="outside">
          <div class="form-label-group">
            <input class="form-control" type="text" id="sentEmailCalendarDropdown" [value]="dateRange"
                   ngbDropdownToggle placeholder="{{'EMAIL-DASHBOARD.SENT-DATE' | translate}}" readonly>
            <label for="calendarDropdown">{{'EMAIL-DASHBOARD.SENT-DATE' | translate}}</label>
            <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
              <span class="far fa-calendar"></span>
            </div>
          </div>
          <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
            <div class="row">
              <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
              <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
            </div>
            <div (click)="stopPropagation($event)">
              <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy"
                          [maxDate]="maxDate"
                          readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                          [yearRange]="yearRange" (onSelect)="setMinDate()" [inline]="true"
                          [locale]="calendarLocale"></p-calendar>
              <p-calendar [(ngModel)]="endDate" [defaultDate]="endDate" dateFormat="dd/mm/yy"
                          [minDate]="minDate"
                          readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                          [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                          [locale]="calendarLocale"></p-calendar>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 pl-3 pr-0">
        <div style="padding-top: 5px">
          <div class="form-label-group form-group">
            <input class="form-control" type="text" id="documentNumber" [(ngModel)]="documentNumber"
                   placeholder="{{ 'EMAIL-DASHBOARD.DOC-NUM' | translate }}">
            <label for="documentNumber">{{ 'EMAIL-DASHBOARD.DOC-NUM' | translate }}</label>
          </div>
        </div>
      </div>
      <div class="col-4 px-2 h-50">
        <div class="center">
          <div style="padding-top: 5px">
            <ng-select class="custom" [items]="allBuyerNamesReport"
                       id="buyerName"
                       bindLabel=label
                       placeholder="{{'TAX-B2P.FILTER.BUYER' | translate}}"
                       [(ngModel)]="buyerName"
                       [ngClass]="{'selected': searchingBuyerName || buyerName}"
                       (blur)="searchingBuyerName = false"
                       (focus)="searchingBuyerName = true">
            </ng-select>
            <label *ngIf="searchingBuyerName || buyerName" class="select-label"
                   for="buyerName">{{ 'TAX-B2P.FILTER.BUYER' | translate }}</label>
          </div>
        </div>
      </div>
      <div class="col-4 pr-3 pl-0">
        <div class="center">
          <div style="padding-top: 5px">
            <ng-select class="custom" [items]="allBuyerEmailsReport"
                       id="email"
                       bindLabel=label
                       placeholder="{{'EMAIL-DASHBOARD.EMAIL' | translate}}"
                       [(ngModel)]="email"
                       [ngClass]="{'selected': searchingEmail || email}"
                       (blur)="searchingEmail = false"
                       (focus)="searchingEmail = true">
            </ng-select>
            <label *ngIf="searchingEmail || email" class="select-label"
                   for="email">{{ 'EMAIL-DASHBOARD.EMAIL' | translate }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="col-12 box-parent  mt-3 pr-0 pl-0">
  <div class="pl-2">
    <app-custom-pagination
      [(currentPage)]="currentPage"
      [(itemsPerPage)]="itemsPerPage"
      [totalItems]="totalItems"
      (pageChange)="pageChanged()"
      (optionChange)="searchButtonClicked()"
    >
    </app-custom-pagination>
  </div>

  <div class="row m-t-20" *ngIf="totalItems === 0 && loading_main === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>


  <div class="col-12 m-t-20  scrollable padding-left pl-0 pr-0" *ngIf="!loading_main&&totalItems !== 0">
    <table class="table text-center">
      <thead>

      <th scope="col">{{'EMAIL-DASHBOARD.SENT-DATE' | translate }}</th>
      <th scope="col">{{'FILTER.DOCUMENT-NUMBER' | translate}}</th>
      <th scope="col">{{'TAX-B2P.TABLE.BUYER' | translate}}</th>
      <!--          <th scope="col">Document No</th>-->
      <!-- <th scope="col">{{'FILTER.CUSTOMER-CODE' | translate}}</th>
      <th scope="col">{{'FILTER.DELIVERY-CODE' | translate}}</th> -->
      <th scope="col">{{'ISSUE-TEXT.BROKER-NAME' | translate}}</th>
      <th scope="col">{{'EMAIL-DASHBOARD.EMAIL' | translate}}</th>
      <th scope="col">{{'RD-SEND-REPORT.RESEND' | translate}}</th>
      <th scope="col">{{'EMAIL-DASHBOARD.STATUS' | translate}}</th>
      </thead>
      <tbody>

      <tr *ngFor="let res of tableData; let i = index">
        <td class="align-top">{{ res.sent_date }}</td>
        <td class="align-top">
          <span [innerHTML]="res.document_number.join('<br>')"></span>
        </td>
        <td class="align-top" style="max-width: 250px; white-space: pre-wrap;">{{res.buyer_name}}</td>
        <td class="align-top" style="max-width: 250px; white-space: pre-wrap;">{{res.broker_name}}</td>
        <!-- <td class="align-top">{{res.customer_code}}</td>
        <td class="align-top">{{res.delivery_code}}</td> -->
        <td class="align-top">
          <div class="row flex-nowrap">
            <div class="col-auto">To:</div>
            <div class="col-auto text-left">
              <span [innerHTML]="res.email_data.join('<br>')"></span>
            </div>
          </div>
          <br>
          <div class="row flex-nowrap">
            <div class="col-auto">CC:</div>
            <div class="col-auto text-left">
              <span [innerHTML]="res.cc_email_data.join('<br>')"></span>
            </div>
          </div>
        </td>
        <td class="align-top">
          <button class="btn btn-dv btn-wide" (click)="openMailModal(i)">
            <i class="fas fa-envelope m-r-5"></i>
          </button>
        </td>
        <!-- <td class="align-top">{{res.status}}</td> -->
        <td class="align-top" *ngIf="res.status=='failed'"><i class="fa fa-circle" style="color: #FF6384"
                                                              aria-hidden="true"></i></td>
        <td class="align-top" *ngIf="res.status=='success'"><i class="fa fa-circle" style="color: #16c8c8"
                                                               aria-hidden="true"></i></td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="row m-t-20" *ngIf="loading_main">
    <div class="col-12 text-center">
      <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.html